import { Crown, RefreshCw, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, PageHeader, Spinner } from "@/components/Common";
import { MorningEmailCard, PlanDay, PlanProgress, StreakPills } from "@/components/plan/PlanParts";
import { askUpgrade, todayIndex, usePaidPlan, useWeekPlan } from "@/lib/weekPlan";

export default function Calendar() {
  const paid = usePaidPlan();
  const { plan, busy, toggle, replan } = useWeekPlan(paid);
  const sections = plan?.result?.sections || [];
  const done = new Set(plan?.progress?.done || []);
  const tIdx = todayIndex(sections);

  return (
    <div>
      <PageHeader title="Weekly plan" subtitle={plan?.result?.summary || "Your week as a checklist. Tick tasks off as you go."}>
        {paid && <Button onClick={replan} disabled={busy} data-testid="calendar-replan-button">{busy ? <Spinner /> : plan ? <><RefreshCw className="h-4 w-4" />Re-plan my week</> : <><Sparkles className="h-4 w-4" />Plan my week</>}</Button>}
      </PageHeader>
      {!paid ? (
        <Card className="max-w-xl" data-testid="calendar-upsell">
          <p className="text-sm text-zinc-300">Plan your week with AI, tick off tasks, build streaks and get your plan by email every morning.</p>
          <Button className="mt-4" onClick={askUpgrade} data-testid="calendar-upgrade-button"><Crown className="h-4 w-4" />Unlock with Pro</Button>
        </Card>
      ) : plan === undefined ? <Spinner className="h-6 w-6 text-[#D4AF37]" /> : (
        <div className="grid gap-6 xl:grid-cols-[1fr_320px]">
          <div className="space-y-6">
            {plan ? (
              <>
                <Card className="space-y-4" data-testid="calendar-progress-card">
                  {plan.result?.title && <h3 className="font-display text-lg text-zinc-100">{plan.result.title}</h3>}
                  <StreakPills streak={plan.progress?.streak} />
                  <PlanProgress progress={plan.progress} />
                </Card>
                <div className="grid gap-4 md:grid-cols-2 2xl:grid-cols-3" data-testid="calendar-week">
                  {sections.map((s, si) => <PlanDay key={si} section={s} si={si} done={done} onToggle={toggle} today={si === tIdx} className={si === tIdx ? "order-first" : ""} />)}
                </div>
              </>
            ) : <Card data-testid="calendar-empty"><p className="text-sm text-zinc-400">No plan yet. Tap "Plan my week" and your AI coach will lay out the next 7 days.</p></Card>}
          </div>
          <div><MorningEmailCard /></div>
        </div>
      )}
    </div>
  );
}
